import React from "react";

const AppML_Data = () => {
  return (
    <div className="tutorial-page">
      <h1>AppML Data</h1>
      <p>This is the AppML Data page content.</p>
    </div>
  );
};

export default AppML_Data;
